/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import PartnerBankDetails from "./PartnerBankDetails.container";

export default PartnerBankDetails;
